<template>
  <v-row
    v-if="$vuetify.breakpoint.mdAndUp"
    class="flex-nowrap"
  >
    <!-- Provider -->
    <v-col
      class="d-flex flex-column justify-center align-center
      table-right-border table-right-border-light result-columns-align-width"
      @click="onClickViewDetails"
    >
      <img
        v-if="details.imageSiteRemote"
        :src="details.imageSiteRemote"
        :alt="details.brokerFullName"
        class="provider-logo"
      >
      <div
        v-else
        class="font-weight-bold text-center"
      >
        {{ details.insurer }}
      </div>
      <results-price
        v-if="isViewMonthly"
        :quote="quote"
        :monthly="!isViewMonthly"
        :selected-optional-extras="[]"
        class="info--text pt-2"
      />
    </v-col>
    <!-- Price -->
    <v-col
      class="d-flex flex-column justify-center align-center
      table-right-border table-right-border-light result-columns-align-width"
      @click="onClickViewDetails"
    >
      <results-price
        :quote="quote"
        :monthly="isViewMonthly"
        :cashback="cashback"
        :selected-optional-extras="[]"
      />
    </v-col>

    <!-- Cover Type -->
    <v-col
      class="d-flex flex-column justify-center align-center
                                      table-right-border table-right-border-light
                                      text-center result-columns-align-width"
    >
      <span class="font-weight-bold text-h6">{{ details.coverType }}</span>
    </v-col>

    <!--  Possible options  -->
    <quote-options
      v-for="(option, index) in options"
      :key="`option-${index}`"
      :covered="option.covered"
    />

    <!-- Policy details -->
    <v-col
      class="d-flex flex-column justify-center align-center text-center
                           result-columns-align-width"
    >
      <v-btn
        rounded
        color="success"
        @click="onClickViewDetails"
      >
        <span>More info</span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import ResultsPrice from '@/components/car/Results/ResultsPrice.vue';
import QuoteOptions from './QuoteOptions';

export default {
  name: 'quote-desktop',
  components: {
    ResultsPrice,
    QuoteOptions,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      default: null,
    },
  },
  computed: {
    cashback () {
      return +this.details.cashback;
    },
  },
  methods: {
    onClickViewDetails () {
      this.$emit('click-policy-details');
    },
  },
};
</script>

<style scoped lang="scss">
.provider-logo {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
